export interface AuthResponse {
  firstname: string;
  lastname: string;
  email: string;
  confirmedGDPR: boolean;
}
